export enum OverviewType {
  General = "general",
  ApenABC = "apen-overzicht",
  News = "nieuws-overzicht",
  Mix = "mix",
}

export interface IOverviewCmsData {
  culture: string
  context: string
  resultsFoundLabel: string
  resultTextSingle?: string
  resultTextMultiple?: string
  dateAscendingLabel: string
  dateDescendingLabel: string
  nameAscendingLabel: string
  nameDescendingLabel: string
  apenAbcLabel: string
  readMoreButtonLabel: string
  sortByLabel: string
  overviewType: OverviewType
}
